import fetch from "../fetch";

export default ({ dealCode }) =>
  fetch({
    path: `/abs/deals/${dealCode}/ratings`
  });
